import {
    TableHeader as ReactAriaTableHeader,
    TableHeaderProps,
} from 'react-aria-components'

import { joinStyles } from 'app/utils/theme'

import * as styles from './index.css'

type TableHeaderProperties<T> = TableHeaderProps<T> & {
    className?: string
}

export const TableHeader = <T extends object>({
    className,
    ...properties
}: Readonly<TableHeaderProperties<T>>): JSX.Element => {
    return (
        <ReactAriaTableHeader
            className={joinStyles(styles.root, className)}
            {...properties}
        />
    )
}
